import { useEffect } from "react";

const googleon = () => document.createComment("googleon: all");
const googleoff = () => document.createComment("googleoff: all");

const insertNode = (
  refNode: Node,
  insertNode: Node,
  position: "before" | "after",
) => {
  refNode.parentNode?.insertBefore(
    insertNode,
    position === "before" ? refNode : refNode.nextSibling,
  );
};

const surroundNode = (refNode: Node, before: Node, after: Node) => {
  insertNode(refNode, before, "before");
  insertNode(refNode, after, "after");
};

const waitFor = async (id: string, waitTimeMs = 500) => {
  let el: ReturnType<typeof document.getElementById>;
  while ((el = document.getElementById(id)) == null) {
    await new Promise((res) => setTimeout(res, waitTimeMs));
  }

  return el;
};

export const useGoogleOff = (id: string) => {
  useEffect(() => {
    const surroundNodeById = async () => {
      const nextData = await waitFor(id);
      surroundNode(nextData, googleoff(), googleon());
    };

    surroundNodeById();
  }, [id]);
};
